export const EHS_ACTION = {
    EHS_ORGS : "EHS_ORGS"
}